import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce617374"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "help-text" }
const _hoisted_2 = { class: "matches-area" }
const _hoisted_3 = { class: "list-unstyled matches-list" }

import { ref } from 'vue'
import { useModalAutoHide } from '@/util/AppUtil'
import Modal from '@/util/Modal.vue'
import ProfileCard from '@/manage/ProfileCard.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileRelationshipOwnersModal',
  props: {
    personId: {},
    ownerProfileIds: {},
    spouse: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;



__expose({
  open: () => modalRef.value?.open(),
})

const modalRef = ref<InstanceType<typeof Modal>>()

useModalAutoHide(modalRef)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    class: "profile-rel-owner-modal",
    info: ""
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.spouse ? 'Spouse' : 'Parent') + " relationship", 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, " The selected " + _toDisplayString(_ctx.spouse ? 'spouse' : 'parent') + " relationship is defined in: ", 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("ul", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ownerProfileIds, (id) => {
            return (_openBlock(), _createElementBlock("li", { key: id }, [
              _createVNode(ProfileCard, {
                "person-id": id,
                "show-profile-type": "",
                "this-profile": id == _ctx.personId
              }, null, 8, ["person-id", "this-profile"])
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 512))
}
}

})